export const facultyMenu = [
    {
        title: "Reporting",
        url: "#",
        icon: "bi bi-graph-up-arrow",
        submenu: [
            {
                title: "Total Student",
                url: "/dashboard/report/detail/TotalStudent",  
            },
            {
                title: "Current Batches",
                url: "/dashboard/report/detail/CurrentBatches",
                
            },
            {
                title: "Completed Batches",
                url: "/dashboard/report/detail/CompletedBatches",
                
            },
            {
                title: "Present Student",
                url: "/dashboard/report/detail/PresentStudent",
                
            },
            {
                title: "Absent Student",
                url: "/dashboard/report/detail/AbsentStudent",
                
            },
            {
                title: "Due Fees",
                url: "/dashboard/report/detail/DueFees",
                
            },
             {
                title: "Drop Out",
                url: "/dashboard/report/detail/DropOut",
            },
        ],
     },
     {
        title: "Enquiry",
        url: "/enquiry",
        icon: "bi bi-patch-question", 
    },
    {
        title: "Batch",
        url: "/batch/list",
        icon: "bi bi-ui-checks-grid",
    },
    {
        title: "Attendance History",
        url: "/attendance/history",
        icon: "bi bi-calendar2-check",
    }
];
